import { render } from "./popup.vue?vue&type=template&id=6bf3de0b&scoped=true"
import script from "./popup.vue?vue&type=script&lang=js"
export * from "./popup.vue?vue&type=script&lang=js"

import "./popup.vue?vue&type=style&index=0&id=6bf3de0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf3de0b"]])

export default __exports__